import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import Checkbox from 'app/commonComponents/Checkbox';

function FormCheckbox({ name, ...rest }) {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext();
  return (
    <Checkbox
      checked={values[name]}
      error={touched[name] && !!errors[name]}
      onChange={(checked) => {
        setFieldValue(name, checked);
        setFieldTouched(name, true, false);
      }}
      {...rest}
    />
  );
}

FormCheckbox.propTypes = {
  ...Checkbox.propTypes,
  name: PropTypes.string,
};

export default FormCheckbox;
